export const capitalizeFirstLetter = (string?: string, lowerOtherChars?: boolean) => {
  if (!string) {
    return string
  }
  if (lowerOtherChars) {
    string = string.toLocaleLowerCase()
  }
  return string.charAt(0).toLocaleUpperCase() + string.slice(1)
}
